import store from "../../../redux/store";

const Logout = "[Logout] Action"

export const logOut = () => store.dispatch({type: Logout})